import { render, staticRenderFns } from "./AssessmentValue.vue?vue&type=template&id=a97af2da&scoped=true"
import script from "./AssessmentValue.vue?vue&type=script&lang=js"
export * from "./AssessmentValue.vue?vue&type=script&lang=js"
import style0 from "./AssessmentValue.vue?vue&type=style&index=0&id=a97af2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97af2da",
  null
  
)

export default component.exports